import { IconNames } from '@blueprintjs/icons';
import { Icon } from '@strata/react-status-icons';

interface DownloadBoxProps {
    title: string;
    description?: string;
    fileType: string;
    fileSize?: string;
    icon?: (typeof IconNames)[keyof typeof IconNames];
    downloadUrl: string;
}

export const DownloadBox = ({
    title,
    description = undefined,
    fileType,
    fileSize = undefined,
    icon = IconNames.CLOUD_DOWNLOAD,
    downloadUrl,
}: DownloadBoxProps) => (
    <a
        className="sds_download__container padding__around--x-large"
        href={downloadUrl}
        download
        aria-label={title}
    >
        <div className="sds_download__title-and-description">
            <div className="sds_download__title">{title}</div>
            {description && <div className="sds_download__description">{description}</div>}
        </div>
        <div className="sds_download__file-text">
            <div className="sds_download__file-text__type font-regular--uppercase">{fileType}</div>
            <div className="sds_download__file-text__size">{fileSize}</div>
        </div>
        <Icon icon={icon} size={36} className="sds_download__icon padding__left--medium" />
    </a>
);
